import PageTitle from 'app/router/PageTitle';
import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useViewer } from './useViewer';
import ViewerContainerEmbed from './ViewerContainerEmbed';
import ViewerContainerFullScreen from './ViewerContainerFullScreen';

const ViewerContainer = ({
  config,
  contentGuid,
  showEmbed,
  showHeader,
  pdfLibrary,
  jobGuid,
  standalone,
  externalContentUrl,
  eventParams,
  shouldEnableFullWidth = false,
  onOpenExternal = null,
  shouldConsumption = true,
  contained = false,
  shouldSetPageTitle = false,
}) => {
  const { guid } = useParams();
  const {
    isShowHeader,
    authToken,
    courseGuid,
    lang,
    user,
    controllersConfig,
    pdfConfig,
    docConfig,
    scormMetadata,
    reportErrorSentry,
    pdfLibraryUse,
    isViewerPending,
    skinConfig,
    goToBackViewer,
    jobGuidFromUrl,
    onContentLoaded,
    pageHeading,
    pageHeadingLang,
    pageTitle,
  } = useViewer({
    config,
    contentGuid,
    eventParams,
    guid,
    pdfLibrary,
    standalone,
    showHeader,
    shouldEnableFullWidth,
    shouldConsumption,
  });

  const contentGuidUse = externalContentUrl ? 'externalContent' : contentGuid || guid;

  return (
    pdfLibraryUse !== undefined && (
      <>
        {/* Solo cuando el visor ES la pantalla: embebido titularía por encima de la página que lo monta. */}
        {shouldSetPageTitle && <PageTitle value={pageTitle} />}
        {showEmbed ? (
          <ViewerContainerEmbed
            authToken={authToken}
            contentGuid={contentGuidUse}
            controllersConfig={controllersConfig}
            courseGuid={courseGuid}
            lang={lang}
            pagesRangeShow={config?.pagesRangeShow}
            pdfConfig={pdfConfig}
            pdfLibrary={pdfLibraryUse}
            isViewerPending={isViewerPending}
            showHeader={showHeader}
            user={user}
            jobGuid={jobGuidFromUrl || jobGuid}
            docConfig={docConfig}
            reportErrorSentry={reportErrorSentry}
            scormMetadata={scormMetadata}
            goToBackViewer={goToBackViewer}
            externalContentUrl={externalContentUrl}
            onContentLoaded={onContentLoaded}
            shouldEnableFullWidth={shouldEnableFullWidth}
            onOpenExternal={onOpenExternal}
            contained={contained}
            skinConfig={skinConfig}
          />
        ) : (
          <ViewerContainerFullScreen
            authToken={authToken}
            controllersConfig={controllersConfig}
            courseGuid={courseGuid}
            lang={lang}
            pagesRangeShow={config?.pagesRangeShow}
            pdfConfig={pdfConfig}
            pdfLibrary={pdfLibraryUse}
            isViewerPending={isViewerPending}
            showHeader={isShowHeader}
            user={user}
            contentGuid={contentGuidUse}
            jobGuid={jobGuidFromUrl || jobGuid}
            docConfig={docConfig}
            reportErrorSentry={reportErrorSentry}
            scormMetadata={scormMetadata}
            goToBackViewer={goToBackViewer}
            externalContentUrl={externalContentUrl}
            onContentLoaded={onContentLoaded}
            shouldEnableFullWidth={shouldEnableFullWidth}
            onOpenExternal={onOpenExternal}
            contained={contained}
            pageHeading={pageHeading}
            pageHeadingLang={pageHeadingLang}
            skinConfig={skinConfig}
          />
        )}
      </>
    )
  );
};

ViewerContainer.propTypes = {
  shouldSetPageTitle: PropTypes.bool,
  config: PropTypes.shape({
    pagesRangeShow: PropTypes.array,
    pdfConfig: PropTypes.array,
    disabledFetchData: PropTypes.bool,
  }),
  contentGuid: PropTypes.string,
  showEmbed: PropTypes.bool,
  showHeader: PropTypes.bool,
  pdfLibrary: PropTypes.string,
  jobGuid: PropTypes.string,
  standalone: PropTypes.bool,
  externalContentUrl: PropTypes.string,
  eventParams: PropTypes.shape({
    course: PropTypes.object,
    from: PropTypes.string,
  }),
  shouldEnableFullWidth: PropTypes.bool,
  onOpenExternal: PropTypes.func,
  shouldConsumption: PropTypes.bool,
  contained: PropTypes.bool,
};

export default ViewerContainer;
